import * as signalR from "@microsoft/signalr";
import { useEffect, useState } from "react";
import config from "@/config";
import { getCookie } from "../generic.methods";
import { setSignalRConnectionStatus } from "@/store/slices/general/signalRHubSlice";
import { useDispatch } from "react-redux";

const isWindow = typeof window !== "undefined" ? true : false;
if (isWindow) {
  window.hubs = {};
  window.hubStatuses = {};
}

const useSignalRClient = (props) => {
  const { hubName = undefined } = props || {};
  const [statuses, setStatuses] = useState(isWindow ? window.hubStatuses : {});
  const [RTC, setRTC] = useState(isWindow ? window.hubs : {});
  const dispatch = useDispatch();
  const isSingleHub = typeof hubName === "string" ? true : false;

  const baseURL = config.signalRUrl;

  useEffect(() => {
    _createConnection();
  }, []);

  const _createConnection = () => {
    if (isSingleHub) {
      let hub = createHubInfo(hubName);
      _initConnection(hub);
    } else if (Array.isArray(hubName)) {
      // for initializing multiple hubs
      hubName.map((item) => {
        let hub = createHubInfo(item);
        _initConnection(hub);
      });
    }
  };

  const _initConnection = (hub) => {
    let token = getCookie("CRM-Auth");
    let companyKey = getCookie("companyKey") || props.companyKey;
    let companyName = getCookie("companyName");
    // check if connection already build
    if (Object.keys(window.hubs).length && window.hubs[hub.name]) {
      console.log("already connected");
      // re initialize statuses state when hub is already connected.
      setStatuses(window.hubStatuses);
      return;
    }

    // Create and configure the SignalR connection
    window.hubs[hub.name] = new signalR.HubConnectionBuilder()
      .withUrl(
        `${hub.url}?companyKey=${companyKey}&companyName=${companyName}`,
        {
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets,
          accessTokenFactory: () => `${token}`,
        }
      ) // Replace with your SignalR Hub URL
      .withAutomaticReconnect()
      .build();

    if (window.hubs[hub.name]) {
      let connectedHub = window.hubs[hub.name];
      connectedHub
        .start()
        .then(() => {
          console.log("SignalR connection established");
          window.hubStatuses[hub.name] = true;
          setStatuses({
            ...statuses,
            ...window.hubStatuses,
          });
          setRTC(window.hubs);
          if (hub.name)
            dispatch(
              setSignalRConnectionStatus({ hubName: hub.name, status: true })
            );
        })
        .catch((error) => {
          console.error("Error establishing SignalR connection:", error);
          window.hubStatuses[hub.name] = false;
          setStatuses(window.hubStatuses);
        });

      // Callback for when the connection is successfully reconnected
      connectedHub.onreconnected((connectionId) => {
        // Trigger your callback
        onReconnected(hub.name, connectionId);
      });

      // Optional: Callback for when reconnection is attempted but hasn't succeeded yet
      connectedHub.onreconnecting((err) => {
        dispatch(
          setSignalRConnectionStatus({ hubName: hub.name, status: false })
        );
        console.log("Reconnecting... ", hub.name, err);
      });
    }
  };
  // onReconneected callback function
  const onReconnected = (hubName, id) => {
    console.log("reconnected", hubName, id);
    if (hubName)
      dispatch(setSignalRConnectionStatus({ hubName: hubName, status: true }));
  };

  const createHubInfo = (name) => {
    let hub = {
      name,
      url: `${baseURL}/${name}`,
    };
    return hub;
  };

  const _disconnectHub = (name = "") => {
    if (Object.keys(window.hubs).length && window.hubs[name]) {
      let hub = window.hubs[name];
      hub.stop().then((res) => {
        console.log("connection stop");
        delete window.hubs[name];
        delete window.hubStatuses[name];
      });
    }
  };

  const revokeHubChannels = () => {
    let hubs = Object.keys(window.hubs);
    if (hubs && hubs.length) {
      hubs.map((hub) => {
        _disconnectHub(hub);
      });
    }
  };

  return {
    revokeHubChannels,
    statuses,
    RTC,
  };
};

export default useSignalRClient;
